import styled from "styled-components";

export const Container = styled.div`
  background: var(--background-color);
  display: grid;
  padding: 10px;
  gap: 5px;
  border-radius: 4px;
  h1 {
    font-size: 1.6rem;
    color: var(--color);
  }
  p {
    color: var(--color);
    padding: 10px 0;
  }
`;

export const ButtonContent = styled.div`
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  display: flex;
  width: 100%;
  padding-top: 10px;
`;
